import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { WorkflowStepNames } from '../../../constants/constants'
import Routes from '../../../constants/routes';
import ChooseSubscriptionForm from '../../Common/ChooseSubscriptionForm/ChooseSubscriptionForm';
import './ChooseSubscriptionWorkflowStep.scss';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import * as types from '../../../constants/actionTypes';

class ChooseSubscriptionWorkflowStep extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: false,
            is401Error: false
        };
    }

    onSubscriptionSelected = async (subscription) => {

        try {
            this.setState({ isLoading: true });
            this.props.actions.setActiveUserSubscriptions(this.props.step.subscriptions);
            this.props.actions.setCurrentSubscription(subscription.id, subscription.name, subscription.customerRoleName, subscription.hasMultipleLocations);

            const response = await this.props.actions.getSubscriptionDependentWorkflowSteps();
            if (response.type === types.GET_SUBSCRIPTION_DEPENDENT_WORKFLOW_STEPS_SUCCESS) {
                // Don't complete the workflow step until the new steps have been returned
                this.props.actions.completeWorkflowStep(this.props.step.name);
            } else if (response.type === types.GET_SUBSCRIPTION_DEPENDENT_WORKFLOW_STEPS_FAILURE) {
                Notification("error", "Error", "Unable to get login workflow steps.");
                this.setState({ isLoading: false });
            } 
        } catch (error) {
            Notification("error", "An Error Occurred", error);

            if (error === 'Authorization has been denied for this request.') {
                //redirect to Login Page
                this.setState({ is401Error: true });
            } else {
                this.setState({ isLoading: false });
            }
        }

    }

    render() {
        if (!this.props.user || !this.props.step || this.props.step.name !== WorkflowStepNames.ChooseSubscription) {
            Notification("error", "Error", "Invalid Step Name: Expected " + WorkflowStepNames.ChooseSubscription + " Actual: " + this.props.step.name);
            return (<Redirect to={Routes.LoginPage} />);
        }

        if (this.state.is401Error === true) {
            return (<Redirect to={Routes.LoginPage} />);
        }

        return (
            <LoadingIndicator isLoading={this.state.isLoading} isFullscreen={false}>
                <div className="choose-subscription-workflow-step container">
                    <ChooseSubscriptionForm subscriptions={this.props.step.subscriptions} onSuccess={this.onSubscriptionSelected} />
                </div>
            </LoadingIndicator>
        );
    }

}

ChooseSubscriptionWorkflowStep.propTypes = {
    step: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default ChooseSubscriptionWorkflowStep;
